import Vue from 'vue'
import moment from 'moment'

let defaultQueryStringGet = '?per_page=100&page=1'
export default {
  async get (id = null) {
    try {
      if (!id) {
        return await Vue.http.get(`${this.endpoint}${defaultQueryStringGet}`)
      } else {
        var result = await Vue.http.get(`${this.endpoint}/${id}`)
        return result.body
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async save (model) {
    if (model.id) {
      return Vue.http.post(`${this.endpoint}/${model.id}`, model)
    } else {
      return Vue.http.put(`${this.endpoint}`, model)
    }
  },
  async disable (id) {
    return Vue.http.delete(`${this.endpoint}/${id}`)
  },
  async enable (id) {
    return Vue.http.patch(`${this.endpoint}/${id}`)
  },
  async getEntity (entityName, id = null) {
    try {
      if (!id) {
        return await Vue.http.get(`${this.endpoint}/${entityName}`)
      } else {
        var result = await Vue.http.get(`${this.endpoint}/${entityName}/${id}`)
        return result.body
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  currency (value, symbol) {
    return symbol || '€' + ' ' + parseFloat(value || 0).toFixed(2) // todo
  },
  perc (value) {
    return value + ' %'
  },
  toDate (value) {
    return moment(value).format('DD/MM/YYYY HH:mm:ss')
  }
}



// WEBPACK FOOTER //
// ./src/application/baseApplicationItem.js